import React from "react";

import { ButtonGroup, IconButton } from "@mui/material";

import { CirclePlus, DeleteIcon } from "../../../components/icons";

type Props = {
  onAdd: () => void;
  onRemove: () => void;
  readonly: boolean;
};
const AddRemoveActions = ({ onAdd, onRemove, readonly }: Props) => {
  return (
    <ButtonGroup aria-label="Add or remove item">
      <IconButton
        disabled={readonly}
        onClick={onRemove}
        size="small"
        sx={{ p: 0, pr: "4px" }}
      >
        <DeleteIcon />
        <span className="sr-only">Remove</span>
      </IconButton>
      <IconButton
        disabled={readonly}
        onClick={onAdd}
        size="small"
        sx={{ p: 0 }}
      >
        <CirclePlus />
        <span className="sr-only">Add</span>
      </IconButton>
    </ButtonGroup>
  );
};
export default AddRemoveActions;
